import {
  isEmpty,
  type SplitFieldAccessFunction,
  type TranslationRegistry,
} from '@festina-life/core'
import { useCallback } from 'react'
import { useIntl } from 'react-intl'

import { useLocalStorageShouldTranslate } from './useLocalStorageShouldTranslate'

/**
 * Unlike `useTranslate` which is a 1:1 mapping to the source keys,
 * this hook handles the nullability of server-returned enums and
 * provides a more graceful fallback to missing translations.
 */
export function useTranslateEnum(): SplitFieldAccessFunction<TranslationRegistry> {
  const intl = useIntl()
  const { shouldTranslateEnums } = useLocalStorageShouldTranslate()

  return useCallback(
    (pathBase, key) => {
      if (!shouldTranslateEnums) {
        return key ?? ''
      }

      if (isEmpty(key)) {
        return '-'
      }

      const fullKey = `${pathBase}.${key}`
      const source = intl.formatMessage({ id: fullKey })

      // Using `key` as fallback is relied on by some code (ref:2301)
      return source === fullKey ? key : source
    },
    [intl, shouldTranslateEnums],
  )
}
